import type RootStore from "stores/RootStore";
import { RouteType } from "types/RouteType";
import DataMapperImportStore from "./DataMapperImportStore";
import { DATA_MAPPER_IMPORT_ROUTE } from "../Target/DataMapperTargetStore";
import type DataMapperProfileStateStore from "../DataMapperProfileStateStore";
import { DATA_MAPPER_STEP } from "../DataMapperProfileStateStore";

const importStore = (rootStore: RootStore) => rootStore.dataMapperImportViewStore as DataMapperImportStore;
const stateStore = (rootStore: RootStore) =>
  rootStore.dataMapperProfileStateViewStore as DataMapperProfileStateStore;

/**
 * Data Mapper → Import: dry-run or write the open profile's saved mapping
 * configuration from this tab's source into this tab's target. Gated like the
 * Data Source route. Leaving the page stops listening, not the import: it runs
 * on the server, and coming back catches up with it.
 */
const dataMapperImportRoute: RouteType[] = [
  {
    name: DATA_MAPPER_IMPORT_ROUTE,
    path: "/data-mapper/import",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Import",
        enableRefreshButton: true,
        component: () => import("./DataMapperImport.Header"),
      },
      body: {
        component: () => import("./DataMapperImport.Body"),
        grayBackground: true,
      },
    },
    group: "Data Mapper",
    searchAliases: ["data mapper import", "dry run", "write import", "export to target", "preview import"],
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      // Recorded as the profile's last step, so the Profiles list says it reached Import.
      // Read the profile's saved selection first (it may name the mapping configuration), as the editors do.
      void (async () => {
        await stateStore(rootStore)?.enterStep(DATA_MAPPER_STEP.import);
        await importStore(rootStore)?.enter();
      })();
    },
    onExit: ({ rootStore }) => {
      void stateStore(rootStore)?.flush();
      importStore(rootStore)?.reset();
    },
  },
];

export default dataMapperImportRoute;
